import type { TimelineEvent } from '../actions/types';

export interface ActorDisplay {
    name: string;
    email: string;
    imageURL: string | undefined;
}

function fallbackNameFromCreatedBy(createdBy: string): string {
    if (!createdBy || createdBy === 'unknown') return 'System';
    if (!createdBy.includes('@')) return 'System';
    const local = createdBy.split('@')[0] ?? createdBy;
    return local.replace(/[._]/g, ' ');
}

export function resolveActorDisplay(event: TimelineEvent): ActorDisplay {
    const enriched = event.createdByUser ?? null;
    if (enriched) {
        return {
            name: enriched.name,
            email: enriched.email,
            imageURL: enriched.profilePictureUrl ?? undefined
        };
    }
    const fallbackName = fallbackNameFromCreatedBy(event.createdBy);
    const email = event.createdBy.includes('@') ? event.createdBy : '';
    return { name: fallbackName, email, imageURL: undefined };
}
